import { callable } from '../callable';

export type PrayerScopeType = 'seminary' | 'program' | 'section';
export type PrayerStatus = 'open' | 'answered';

export interface PrayerScopeDto {
  type: PrayerScopeType;
  id?: string;
}

export interface PrayerRequestDto {
  id: string;
  authorPersonId: string;
  authorName: string;
  scope: PrayerScopeDto;
  title: string;
  body: string;
  status: PrayerStatus;
  prayedBy: string[];
  answeredAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const prayerApi = {
  list: async (data: {
    tenantId: string;
    personId?: string;
  }): Promise<{ items: PrayerRequestDto[]; currentPersonId: string }> => {
    const fn = callable<typeof data, { items: PrayerRequestDto[]; currentPersonId: string }>(
      'listPrayerRequests',
    );
    return (await fn(data)).data;
  },
  create: async (data: {
    tenantId: string;
    personId?: string;
    scope: PrayerScopeDto;
    title: string;
    body: string;
  }): Promise<{ id: string }> => {
    const fn = callable<typeof data, { id: string }>('createPrayerRequest');
    return (await fn(data)).data;
  },
  togglePray: async (data: {
    tenantId: string;
    personId?: string;
    requestId: string;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('togglePrayerPray');
    return (await fn(data)).data;
  },
  markAnswered: async (data: {
    tenantId: string;
    personId?: string;
    requestId: string;
    answered: boolean;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('markPrayerAnswered');
    return (await fn(data)).data;
  },
  delete: async (data: {
    tenantId: string;
    personId?: string;
    requestId: string;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('deletePrayerRequest');
    return (await fn(data)).data;
  },
};
